import { TaxSlabCreate } from './TaxSlabCreate';
import { TaxSlabEdit } from './TaxSlabEdit';
import { TaxSlabList } from './TaxSlabList';

export const tax_slabs = {
    list: TaxSlabList,
    create: TaxSlabCreate,
    edit: TaxSlabEdit,
};

export { TaxSlabCreate, TaxSlabEdit, TaxSlabList };
